<template>
    <div >
        <b-form @submit.prevent="create">
<!--            doctortype_id-->
            <b-form-group id="doctortype_id_group" label="Doctor Type " label-for="doctortype_id" description="The doctortype id">
                <b-form-select id="doctortype_id" v-model="form.doctortype_id" type="number" required>
                  <option v-for="type in doctorType" :key="type.id" block :value="type.id" style="font-weight: bold">
                    {{type.name}}
                  </option>
                </b-form-select>
            </b-form-group>

<!--            name-->
            <b-form-group id="name_group" label="Name:" label-for="name" description="The fullname of doctor.">
                <b-form-input id="name" v-model="form.name" type="text" required placeholder="Enter name"></b-form-input>
            </b-form-group>

<!--            bmdc_number-->
            <b-form-group id="bmdc_number_group" label="BMDC Number:" label-for="bmdc_number" description="The registered bmdc_number of doctor. Unique for doctors.">
                <b-form-input id="bmdc_number" v-model="form.bmdc_number" type="text" required placeholder="BMDC Number"></b-form-input>
            </b-form-group>

            <b-row>
              <b-col>
                <!--            rate-->
                <b-form-group id="rate_group" label="Rate:" label-for="rate" >
                  <b-form-input id="rate" v-model="form.rate" type="number" required placeholder="Rate"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col>
                <!--            offer_rate-->
                <b-form-group id="offer_rate_group" label="Offer rate:" label-for="offer_rate" >
                  <b-form-input id="Offer_rate" v-model="form.offer_rate" type="number" placeholder="Offer Rate"></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>


<!--            report_followup_rate-->
            <b-form-group id="report_followup_rate_group" label="Report Follow up Rate:" label-for="report_followup_rate" >
               <b-form-input id="report_followup_rate" v-model="form.report_followup_rate"  placeholder="Report Follow up Rate"></b-form-input>
            </b-form-group>

            <b-form-group id="followup_rate_group" label = "Follow up rate" label-for="follow_up">
              <b-form-input id="follow_up" v-model="form.followup_rate" placeholder="Follow up rate"></b-form-input>
            </b-form-group>

            <b-form-group id="commission_group" label="Commission Group" label-for="commission">
              <b-form-input id="commission" v-model="form.commission" placeholder="Enter commission percentage"></b-form-input>
            </b-form-group>

<!--            gender-->
            <b-form-group id="gender_group" label="Gender" label-for="gender" description="The gender of doctor.">
                <b-form-select id="gender" v-model="form.gender" type="number" :options="gender" required></b-form-select>
            </b-form-group>

<!--            mobile-->
            <b-form-group id="mobile_group" label="Mobile" label-for="mobile" description="The mobile of doctor. Must be unique.">
                <b-form-input id="mobile" v-model="form.mobile" required type="text" placeholder="Enter mobile number"></b-form-input>
            </b-form-group>

<!--            email-->
            <b-form-group id="email-group" label="Email address:" label-for="email" description="The mail address of doctor.">
                <b-form-input id="email" v-model="form.email" type="email" required placeholder="Enter email"></b-form-input>
            </b-form-group>

<!--            workplace-->
            <b-form-group id="workplace_group" label="Work Place :" label-for="workplace" description="The workplace of doctor.">
                <b-form-input id="workplace" v-model="form.workplace" type="text" required placeholder="Enter doctor's work place"></b-form-input>
            </b-form-group>

<!--            designation-->
            <b-form-group id="designation_group" label="Designation :" label-for="designation" description="The designation of doctor.">
                <b-form-input id="designation" v-model="form.designation" type="text" required placeholder="Enter Designation of Doctor"></b-form-input>
            </b-form-group>

<!--            medical_college-->
            <b-form-group id="medical_college_group" label="Medical College :" label-for="medical_college" description="The graduation college of doctor.">
                <b-form-input id="medical_college" v-model="form.medical_college.name" type="text" required placeholder="Enter Medical College"></b-form-input>
            </b-form-group>

            <b-row>
              <b-col>
                <b-form-group id="batch_group" label="Batch *" label-for="batch" description="Enter your Batch number.">
                  <b-form-input id="batch" v-model="form.medical_college.batch" type="text" required placeholder="Batch"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group id="session" label="Session *" label-for="session" description="Enter Session">
                  <b-form-input id="session" v-model="form.medical_college.session" type="text" required placeholder="Session"></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>


          <!--            post_grad-->
            <b-form-group id="post_grad_group" label="Post Grad :" label-for="post_grad" description="Post Grad degree of doctor">
                <b-form-input id="post_grad" v-model="form.postgrad" required type="text" placeholder="Post grad"></b-form-input>
            </b-form-group>

<!--            others_training-->
            <b-form-group id="others_training_group" label="Others Training :" label-for="others_training" description="Other degrees of doctor [can be blank].">
                <b-form-input id="others_training" v-model="form.other_trainings" required type="text" placeholder="Other Trainings"></b-form-input>
            </b-form-group>


           <b-row>
               <div style="padding-right: 10px; padding-left: 15px; ">
                   <b-button type="submit" variant="danger">Create</b-button>
               </div>
           </b-row>
        </b-form>
        <b-card class="mt-3" header="Form Data Result">
            <pre class="m-0">{{ form }}</pre>
        </b-card>
    </div>
</template>

<script>
    import { Form } from 'vform';
    import DoctorService from "@/services/admin/doctor.service";
    export default {
        data() {
            return {
              form: new Form(
                  {
                    doctortype_id: null,
                    payment_style: 0,
                    name: null,
                    bmdc_number: null,
                    rate: null,
                    offer_rate: null,
                    report_followup_rate: null,
                    followup_rate: null,
                    commission: null,
                    gender: null,
                    mobile: null,
                    email: null,
                    workplace: null,
                    designation: null,
                    medical_college: {
                      name: '',
                      session: '',
                      batch: '',
                    },
                    postgrad: null,
                    other_trainings: null,
                    portfolio: ' ',
                  }
              ),
                doctorType: null,
                gender: [{text: 'Male', value: 0},{text: 'Female', value: 1}],
                value: ''
            }
        },
        methods: {
          create(){
            DoctorService.createDoctor(this.form)
                .then((resposne) => {
                  if (resposne.status === 201) {
                    alert("Doctor created");
                  }
                  else{
                    alert("could not create doctor")
                  }
                })
          },
        },
        mounted() {
          DoctorService.fetchDoctorTypes()
          .then((response) =>{
            if(response.status === 200){
              this.doctorType = response.data;
            }
          })
          .catch((e) => {
            console.log(e);
          })
        }
    }
</script>
